import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './PrivacyPolicy';
import PrivacyPolicyThiru from './PrivacyPolicyThiru';
import FourFourFourAI from './LandingFourFourFourAI';
import ThirukuralAI from './LandingThirukuralAI';
import Aileesa from './LandingAileesa';
import PrivacyPolicyAileesa from './PrivacyPolicyAileesa';

function HomePage() {
  return (
    <div className="App">
      <header className="App-header">
        <p id='logo' title="01001011">
        01001011
        </p>
        <p id='sub_title'>A Technology Company!</p> <br></br>
        <a href='mailto:superkarthi789@gmail.com' id='enquiry'>Enquire ✉️</a>
      </header>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/444-ai" element={<FourFourFourAI />} />
        <Route path="/444-ai/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/thirukural-ai" element={<ThirukuralAI />} />
        <Route path="/thirukural-ai/privacy-policy" element={<PrivacyPolicyThiru />} />
        <Route path="/aileesa" element={<Aileesa />} />
        <Route path="/aileesa/privacy-policy" element={<PrivacyPolicyAileesa />} />
      </Routes>
    </Router>
  );
}

export default App;
